import React, { useEffect, useState } from "react";
import { TL } from "../i18n";
import client from "../lib/api";
import { AlertTriangle } from "lucide-react";

// Flashing account-alert banner shown on each app's main dashboard. Surfaces currency
// pools whose balance has crossed a user-defined alert threshold (above / below).
export function PoolAlertFlasher() {
  const [breaches, setBreaches] = useState([]);
  useEffect(() => {
    let alive = true;
    const load = () => client.get("/currencies").then((r) => {
      const out = [];
      (r.data || []).forEach((c) => {
        const bal = Number(c.balance || 0);
        const lo = c.alert_low, hi = c.alert_high;
        if (lo !== "" && lo != null && !isNaN(Number(lo)) && bal < Number(lo))
          out.push({ id: c.id, name: c.name, kind: "below", bal, threshold: Number(lo) });
        else if (hi !== "" && hi != null && !isNaN(Number(hi)) && bal > Number(hi))
          out.push({ id: c.id, name: c.name, kind: "above", bal, threshold: Number(hi) });
      });
      if (alive) setBreaches(out);
    }).catch(() => {});
    load();
    const t = setInterval(load, 30000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  if (!breaches.length) return null;
  return (
    <div className="alert-flash mb-4 rounded-lg border border-[#DA1E28]/50 bg-[#DA1E28]/10 p-3" data-testid="pool-alert-flasher" role="alert">
      <div className="flex items-center gap-2 text-sm font-semibold text-[#DA1E28]">
        <AlertTriangle size={16} className="shrink-0" />
        <span>Account alerts — {breaches.length} pool{breaches.length > 1 ? "s" : ""} need attention</span>
      </div>
      <div className="mt-2 flex flex-wrap gap-2">
        {breaches.map((b) => (
          <span key={b.id} data-testid={`pool-alert-${b.id}`}
            className="inline-flex items-center gap-1 rounded-full bg-white/70 dark:bg-black/30 px-2.5 py-1 text-xs">
            <strong>{b.name}</strong>
            <span className="opacity-70">{b.kind === "below" ? "below" : "above"} {b.threshold.toLocaleString()}</span>
            <span className="opacity-50">(now {b.bal.toLocaleString()})</span>
          </span>
        ))}
      </div>
    </div>
  );
}
